import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle
} from "react";
import {
  EditorState,
  convertToRaw,
  convertFromRaw,
  ContentState
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./SongEditor.scss";
import { DEFAULT_ROW } from "../../../@core/constants";

interface SongEditorProps {
  row: string;
  onRowChange: (row: string) => void;
}

type EditorStateInterface = [
  editorState: EditorState,
  setEditorState: (editorState: EditorState) => void
];

const SongEditor = forwardRef(function SongEditor(
  { row, onRowChange }: SongEditorProps,
  ref
) {
  const [editorState, setEditorState]: EditorStateInterface =
    useState<EditorState>(
      EditorState.createWithContent(
        convertFromRaw(JSON.parse(row || DEFAULT_ROW))
      )
    );

  const onEditorStateChange = (editorState: EditorState) => {
    setEditorState(editorState);
    const row = convertToRaw(editorState.getCurrentContent());
    onRowChange(JSON.stringify(row));
  };

  const updateEditorContent = (newContent: string) => {
    // Remove both "Normal" and "Font" at the start of the content
    let cleanedContent = newContent.replace(
      /^(Normal|Font)\s*(Normal|Font)?\s*/i,
      ""
    );
    // Remove extra empty lines (consecutive empty lines will be reduced to one)
    cleanedContent = cleanedContent.replace(/(\n{2,})/g, "\n\n");

    // Now create the content state and editor state
    const newContentState = ContentState.createFromText(cleanedContent);
    const newEditorState = EditorState.createWithContent(newContentState);

    // Update the editor state
    setEditorState(EditorState.moveFocusToEnd(newEditorState));
  };

  // ✅ Expose methods to the parent via ref
  useImperativeHandle(ref, () => ({
    //resetEditor: () => setEditorState(EditorState.createEmpty()), // Clears content
    setContent: (text: string) => updateEditorContent(text), // Update content
    focusEditor: () => setEditorState(EditorState.moveFocusToEnd(editorState)) // Move focus
  }));

  return (
    <div className="song-editor">
      <Editor
        wrapperClassName="wrapper"
        //toolbarClassName="toolbar"
        editorClassName="editor"
        editorState={editorState}
        onEditorStateChange={onEditorStateChange}
      />
    </div>
  );
});

export default SongEditor;
